import { ItemListing } from '~/mappers/itemListing/models';

export const filterListingItemsByBrand = (
  products: ItemListing[],
  brandName: string | undefined,
  limit = 12
): ItemListing[] => {
  if (products.length === 0 || !brandName) return [];

  return products
    .filter((product) => product.productBrand?.[0]?.brandName === brandName)
    .slice(0, limit);
};
